// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn_ec/v1/legacy_portal_service.proto (package spwn.spwn_ec.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { LegacyPortalLiveCommerceProduct } from "./legacy_portal_common_pb";
/**
 * @generated from message spwn.spwn_ec.v1.LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest
 */
export class LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest extends Message {
    constructor(data) {
        super();
        /**
         * イベントID（Shopify 商品タグの元になる）
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest, a, b);
    }
}
LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest.runtime = proto3;
LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest.typeName = "spwn.spwn_ec.v1.LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest";
LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "first", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.spwn_ec.v1.LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse
 */
export class LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse extends Message {
    constructor(data) {
        super();
        /**
         * ライブコマース商品の一覧
         *
         * @generated from field: repeated spwn.spwn_ec.v1.LegacyPortalLiveCommerceProduct products = 1;
         */
        this.products = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse, a, b);
    }
}
LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse.runtime = proto3;
LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse.typeName = "spwn.spwn_ec.v1.LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse";
LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "products", kind: "message", T: LegacyPortalLiveCommerceProduct, repeated: true },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map